import { FunctionComponent } from 'react';
import { IBwjRowProps, Row } from './row';
import { Col } from './col';

export const RowCol: FunctionComponent<IBwjRowProps> = (props) => {

  return (
    <Row bottomSpacing={props.bottomSpacing}>
      <Col small={12}>
        {props.children}
      </Col>
    </Row>
  );
};